import {LANGUAGE,SCREEN_NUMBER,SCORE,PLAYTIME,RANDAMIZE,SETMYTHSANDFACTS,SETCURRENTINDEX,SETCURRENTQUESTION,SETSHOWCORRECTWRONG} from './typs';



export function setLanguage(lang){
  localStorage.setItem('language',lang);
    return {
        type: LANGUAGE,
        language:lang
      }
}

export function setGameScreenNumber(screenNumber,oldScreenNumber){
      return{
        type: SCREEN_NUMBER,
        screenNumber:screenNumber,
        oldScreenNumber:oldScreenNumber
      }
}

export function setScore(score){
  return{
    type:SCORE,
    score:score
  }
}

export function setTime(playTime){
  return{
    type:PLAYTIME,
    playTime:playTime
  }
}

export function isArrayRandamized(israndamized){
  return{
    type:RANDAMIZE,
    israndamized:israndamized
  }
}

export function setRandomMythsAndFacts(mytnsAndFacts){
  return{
    type:SETMYTHSANDFACTS,
    randMythsAndFacts:mytnsAndFacts
  }
}

export function setCurrentIndex(currentIndex){
  return{
    type:SETCURRENTINDEX,
    currentIndex:currentIndex
  }
}

export function setCurrentQuestion(currentQuestion){
  return{
    type:SETCURRENTQUESTION,
    currentQuestion:currentQuestion
  }
}

export function showCorrectWrongImage(showCorrectWrong){
  return{
    type:SETSHOWCORRECTWRONG,
    showCorrectWrong:showCorrectWrong
  }
}




// WEBPACK FOOTER //
// ./src/actions/commonActions.js